import { defineElement, createView, injectView } from "domvm";
import { Control } from "./Control.js";

export class Component extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        this.controls = [];

        this._view = createView((vm, component) => () => component._render(vm), this);

    };

    // --------------------------------------------------------------------------------------------

    getControls() {

        return this.controls;

    };

    // --------------------------------------------------------------------------------------------

    async prepare(options) {

        await super.prepare(options);
        await Promise.all(this.getControls().map(control => control.prepare(options)));

    }

    async refresh(options) {

        await super.refresh(options);
        await Promise.all(this.getControls().map((control) => control.refresh(options)));

    };

    // --------------------------------------------------------------------------------------------

    mountControl(control, invalidate = false) {

        if (!control)
            return null;
        if (this.controls.includes(control))
            throw new Error('[Component] Control is already mounted.');
        if (control.parent)
            throw new Error('[Component] Control is already mounted in another component.');

        this.controls.push(control);
        control.parent = this;

        if (invalidate)
            this.invalidate();

        return control;

    };

    unmountControl(control, invalidate = false) {

        if (control.parent != this)
            throw new Error('[Component] Control is mounted in another component.');

        var index = this.controls.indexOf(control);
        if (index < 0)
            return;

        this.controls.splice(index, 1);
        control.parent = null;
        
        if (invalidate)
            this.invalidate();

    };

    unmountAllControls(invalidate = false) {

        this.controls.splice(0, this.controls.length);

        if (invalidate)
            this.invalidate();

    };

    // --------------------------------------------------------------------------------------------

    render(vm) {

        if (!this._view)
            return null;
        return injectView(this._view, this);

    };

    /**
     * DOM-VM view node renderer.
     * @param {*} vm - Component DOM-VM viewmodel
     * @param {*} component - Component data
     * @returns DOM-VM element node.
     */
    _render(vm, component) {

        const el = defineElement;

        return el('div', [
            '[Component]'
        ]);

    };

    invalidate(level = 0) {

        const parent = this.getParent();

        if (parent && level > 0) {
            parent.invalidate(--level);
            return;
        }

        const view = this._view;

        if (view && level <= 0) {
            this._view.redraw();
            return;
        }
        if (parent) {
            parent.invalidate(--level);
        }

    };


}